
/**
 * @override
 */
Foundation.Login.Dialog.prototype.setView = function (view) {
    // Verify that the user is not already logged in before continuing
    // with showing the user the modal view.
    if (this.xJSON && this.xJSON["auth"]) {
        var sessionManager = Foundation.Session.Manager.sharedInstance();

        sessionManager.observe("login", this.close.bind(this));

        var member = new Foundation.Member(this.xJSON["auth"]["oid"]);
        member.set("userName", this.xJSON["auth"]["userName"]);
        sessionManager.logIn(this.xJSON["auth"]["delegate"], member);

        return;
    }

    Foundation.Component.Ajax.prototype.setView.call(this, view);
};

/**
 * Initialize the microcomponents and event handlers.
 * @private
 */
Foundation.Login.Dialog.prototype.init = function () {
    // Initialize microcomponents.
    var mobile = Foundation.MOBILE ? "Mobile" : "";
    this.logInComponent = this.registerMicroComponent(new Foundation.Login.Dialog.LogInComponent(`LogIn${mobile}`));
    if (this.loginLaunchToggle) {this.emailSignInComponent = this.registerMicroComponent(new Foundation.Login.Dialog.EmailSignInComponent(`EmailSignIn${mobile}`));}
    this.createAccountComponent = this.registerMicroComponent(new Foundation.Login.Dialog.CreateAccountComponent(`CreateAccount${mobile}`));
    this.passwordResetComponent = this.registerMicroComponent(new Foundation.Login.Dialog.PasswordResetComponent(`PasswordReset${mobile}`));
    this.createAccountExtrasComponent = this.registerMicroComponent(new Foundation.Login.Dialog.CreateAccountExtrasComponent(`CreateAccountExtras${mobile}`));
    this.linkAccountComponent = this.registerMicroComponent(new Foundation.Login.Dialog.LinkAccountComponent(`LinkAccount${mobile}`));
    this.feelingShyComponent = this.registerMicroComponent(new Foundation.Login.Dialog.FeelingShyComponent(`FeelingShy${mobile}`));

    // Set up component switching link click handlers.
    this.view.find("a[href$='#LogIn']").click(this.showSubView.bind(this, "LogIn"));
    if (this.loginLaunchToggle) {this.view.find("a[href$='#EmailSignIn']").click(this.showSubView.bind(this, "EmailSignIn"));}
    this.view.find("a[href$='#CreateAccount']").click(this.showSubView.bind(this, "CreateAccount"));
    this.view.find("a[href$='#PasswordReset']").click(this.showSubView.bind(this, "PasswordReset"));
    this.view.find("a[href$='#FeelingShy']").click(this.showSubView.bind(this, "FeelingShy"));
    this.view.find("a[href$='#LinkAccount']").click(this.showSubView.bind(this, "LinkAccount"));
    this.view.find("a[href$='#CreateAccountExtras']").click(this.showSubView.bind(this, "CreateAccountExtras"));

    // Set up social log in links.
    this.view.find("a[href$='#LogInWithFacebook']").click(this.facebookLogIn.bind(this));
    this.view.find("a[href$='#LogInWithTwitter']").click(this.twitterLogIn.bind(this));
    this.view.find("a[href$='#LogInWithGoogle']").click(this.googleLogIn.bind(this));

    // Get notified when the user opts for a "feeling shy" login.
    this.feelingShyComponent.bind("login", this, this.feelingShyLogIn);

    // Close the modal dialog box when the log in has been successful.
    Foundation.Session.Manager.sharedInstance().bind("login", this.dialog, this.dialog.close);

    // Show and initialize the first visible subview microcomponent.
    this.showSubView(this.visibleMicroComponent());

    // Let's double check that the user is winding up on the right screen.
    // It's possible that when they have an account to link with Facebook
    // or there are extra fields they still need to fill out to register.
    // Doing this here means that the screen will suddenly switch out from
    // underneath them if this is the case, but this seems like the only
    // way to get this to work.
    Foundation.Session.Manager.sharedInstance().revalidate();
};

/**
 * Returns the Foundation.Member object we are authenticating or
 * signing up.
 * @return {Foundation.Member}
 */
Foundation.Login.Dialog.prototype.member = function () {
    return this.options["member"]
}

/**
 * Show a different subview.
 * @param {string|Foundation.Component} component
 * @param {jQuery.Event=} e
 * @private
 */
Foundation.Login.Dialog.prototype.showSubView = function (component, e) {
    if (e) e.preventDefault();

    this.hideSpinner();

    if (this.loginLaunchToggle) {
        if (Foundation.isString(component)) {
            const components = {
                "LogIn": this.logInComponent,
                "EmailSignIn": this.emailSignInComponent,
                "CreateAccount": this.createAccountComponent,
                "PasswordReset": this.passwordResetComponent,
                "CreateAccountExtras": this.createAccountExtrasComponent,
                "LinkAccount": this.linkAccountComponent,
                "FeelingShy": this.feelingShyComponent,
                "LogInFacebook": this.logInFacebookComponent
            };
            component = components[component];
        }
    }
    else {
        if (Foundation.isString(component)) {
            const components = {
                "LogIn": this.logInComponent,
                "CreateAccount": this.createAccountComponent,
                "PasswordReset": this.passwordResetComponent,
                "CreateAccountExtras": this.createAccountExtrasComponent,
                "LinkAccount": this.linkAccountComponent,
                "FeelingShy": this.feelingShyComponent,
                "LogInFacebook": this.logInFacebookComponent
            };
            component = components[component];
        }
    }

    var visibleMicroComponent = this.visibleMicroComponent();

    if (visibleMicroComponent && visibleMicroComponent !== component) {
        visibleMicroComponent.view.fadeOut(150, function () {
            visibleMicroComponent.view.hide();
            component.view.fadeIn(150);
            this.dialog.redraw();
        }.bind(this));
        visibleMicroComponent.fire("hidden");
    }
    else if (visibleMicroComponent === null) {
        component.view.show();
    }

    component.fire("shown");
};

/**
 * Perform a Facebook log in.
 * @param {jQuery.Event} e
 */
Foundation.Login.Dialog.prototype.facebookLogIn = function (e) {
    if (e) e.preventDefault();

    var fbAuthenticator = new Foundation.Facebook.Authenticator();
    this._startThirdPartyLoginWithAuthenticator(fbAuthenticator);
};

/**
 * Perform a Twitter log in.
 * @param {jQuery.Event} e
 */
Foundation.Login.Dialog.prototype.twitterLogIn = function (e) {
    if (e) e.preventDefault();
    var twitterAuthenticator = new Foundation.Twitter.Authenticator();
    this._startThirdPartyLoginWithAuthenticator(twitterAuthenticator);
};

/**
 * Perform a Google log in.
 * @param {jQuery.Event} e
 */
Foundation.Login.Dialog.prototype.googleLogIn = function (e) {
    if (e) e.preventDefault();
    var googAuthenticator = new Foundation.Google.Authenticator();
    this._startThirdPartyLoginWithAuthenticator(googAuthenticator);
};

/**
 * @param {Foundation.Observable.Event=} e
 */
Foundation.Login.Dialog.prototype.feelingShyLogIn = function (e) {
    if (this.feelingShyDelegate) {
        this.feelingShyDelegate(e.data);
    }
    this.close();
};

/**
 * @return {Foundation.Login.ThirdPartyAuthenticator}
 */
Foundation.Login.Dialog.prototype.authenticator = function () {
    if (!this._thirdPartyAuthShepherd) return null;
    return this._thirdPartyAuthShepherd.authenticator();
}

/**
 * @private
 * @param {!Foundation.Login.ThirdPartyAuthenticator} authenticator
 */
Foundation.Login.Dialog.prototype._startThirdPartyLoginWithAuthenticator = function (authenticator) {
    this._thirdPartyAuthShepherd = new Foundation.Login.Dialog.ThirdPartyAuthenticationShepherd(this.member(), authenticator);

    this._thirdPartyAuthShepherd.observe("auth-start", function () {
        this.showSpinner()
    }.bind(this))

    this._thirdPartyAuthShepherd.observe("auth-complete", function () {
        this.hideSpinner()
    }.bind(this))

    this._thirdPartyAuthShepherd.observe("need-new-account", function () {
        this.showSubView("CreateAccountExtras")
    }.bind(this))

    this._thirdPartyAuthShepherd.observe("need-login-to-link-account", function () {
        this.showSubView("LinkAccount")
    }.bind(this))

    this._thirdPartyAuthShepherd.authenticate();
}
